// @flow
// $FlowFixMe
import React from 'react';
import { Tag } from '../Tags';
import type { TagType } from '../../types';
import { Autocomplete, TagAutocompleteBlock } from './partials';

type Props = {
  selectedTags: Array<TagType>,
  addTag: Function,
  removeTag: Function,
  removeLatestTag: Function
};

export const TagAutocomplete = ({ selectedTags, addTag, removeTag, removeLatestTag }: Props) => (
  <TagAutocompleteBlock>
    {selectedTags.length ? (
      <div style={{ padding: '0 0 20px 0', display: 'block' }}>
        {selectedTags.map(tag => (
          <Tag key={tag.id} tag={tag} handleDelete={removeTag} />
        ))}
      </div>
    ) : null}
    <Autocomplete handleAddTag={addTag} removeLatestTag={removeLatestTag} hasTags={selectedTags.length} />
  </TagAutocompleteBlock>
);
